import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import { PaymentRequestResponse, PaymentRequestResult } from "../types";

export const paymentRequestService = {
  async getPaymentRequestData(
    dbName: string
  ): Promise<ApiResponse<PaymentRequestResponse>> {
    return apiClient.post<PaymentRequestResponse>("/gestorPaymentRequestViz", {
      dbName,
    });
  },

  async requestPayment(
    dbName: string,
    ops: string,
    dateToCheckout: string
  ): Promise<ApiResponse<PaymentRequestResult>> {
    return apiClient.post<PaymentRequestResult>("/gestorPaymentRequest", {
      dbName,
      ops,
      dateToCheckout,
    });
  },
};
